var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"df-footer"},[_c('div',{staticClass:"df-footer-content"},[_c('div',{staticClass:"df-flex df-flex-col"},[_c('div',{staticClass:"df-footer-links",domProps:{"innerHTML":_vm._s(_vm.selexFooter)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }